import {
	bankParams,
	bookmarkParams,
	collectionDetailParams,
	collectionParams,
	deployDetailParams,
	normalizeCollectionResponse,
	normalizeRecordResponse,
	projectDetailParams,
	subscriptionDetailParams,
	workspaceParams,
} from 'api';
import { client, computeHeaders } from 'queries';

export const workspaceQuery = async ({ req, params, query }) => {
	const formattedParams = { ...workspaceParams, context: query.context ? query.context : ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/workspace`, headers, params: formattedParams });
	return normalizeRecordResponse(response);
};

export const workspaceAgentToolsQuery = async ({ req }) => {
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/workspace/tools`, headers });
	return normalizeCollectionResponse(response);
};

export const workspaceSecretsQuery = async ({ req }) => {
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/workspace/secrets`, headers });
	return normalizeRecordResponse(response);
};

export const workspaceMerchantAccountQuery = async ({ req }) => {
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/workspace/merchant-account`, headers });
	return normalizeRecordResponse(response);
};

export const workspaceBankQuery = async ({ req }) => {
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/workspace/bank`, headers, params: bankParams });
	return normalizeRecordResponse(response);
};

export const workspaceBookmarksQuery = async ({ req, params, query }) => {
	const formattedParams = { ...bookmarkParams, context: query.context ? query.context : ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/workspace/bookmarks`, headers, params: formattedParams });
	return normalizeCollectionResponse(response);
};

export const workspaceCollectionQuery = async ({ req, params, query }) => {
	const formattedParams = { ...collectionDetailParams, context: query.context ? query.context : ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({
		url: `/workspace/collections/${params.collectionId}`,
		headers,
		params: formattedParams,
	});
	return normalizeRecordResponse(response);
};

export const workspaceCollectionsQuery = async ({ req, params, query }) => {
	const formattedParams = { ...collectionParams, context: query.context ? query.context : ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/workspace/collections`, headers, params: formattedParams });
	return normalizeCollectionResponse(response);
};

export const workspaceDeployQuery = async ({ req, params, query }) => {
	const formattedParams = { ...deployDetailParams, context: query.context ? query.context : ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({
		url: `/workspace/deploys/${params.deployId}`,
		headers,
		params: formattedParams,
	});
	return normalizeRecordResponse(response);
};

export const workspaceProjectQuery = async ({ req, params, query }) => {
	const formattedParams = { ...projectDetailParams, ...query, context: query.context ? query.context : ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({
		url: `/workspace/projects/${params.projectId}`,
		headers,
		params: formattedParams,
	});
	return normalizeRecordResponse(response);
};

export const workspaceProjectBranchesQuery = async ({ req, params }) => {
	const formattedParams = { page: 0, pageSize: '*', query: '' };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({
		url: `/workspace/projects/${params.projectId}/branches`,
		headers,
		params: formattedParams,
	});
	return normalizeCollectionResponse(response);
};

export const workspaceNotificationsQuery = async ({ req, params, query }) => {
	const formattedParams = { ...query, context: query.context ? query.context : ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/workspace/notifications`, headers, params: formattedParams });
	return normalizeCollectionResponse(response);
};

export const sessionReferralsQuery = async ({ req, params, query }) => {
	const formattedParams = { context: query.context ? query.context : ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/session/referrals`, headers, params: formattedParams });
	return normalizeCollectionResponse(response);
};

export const sessionReferralStatsQuery = async ({ req, params, query }) => {
	const formattedParams = { context: query.context ? query.context : ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/session/referral-stats`, headers, params: formattedParams });
	return normalizeRecordResponse(response);
};

export const workspaceSubscriptionQuery = async ({ req, params, query }) => {
	const formattedParams = { ...subscriptionDetailParams, context: query.context ? query.context : ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/workspace/subscription`, headers, params: formattedParams });
	return normalizeRecordResponse(response);
};

export const workspaceViewsQuery = async ({ req, params, query }) => {
	const formattedParams = { context: query.context ? query.context : ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/workspace/views`, headers, params: formattedParams });
	return normalizeCollectionResponse(response);
};
